import Cookies from 'js-cookie';
import dialogPolyfill from 'dialog-polyfill';
const bodyScrollLock = require('body-scroll-lock');

export default dialog => dialogPolyfill.registerDialog(dialog);

var cookiesConsentAnswer = Cookies.get('_cookies-consent');
var mayShowDialog = true;

if (!cookiesConsentAnswer) {
    showDialog();
}

function showDialog() {
    // Ask for consent with popup
    var dialog = document.querySelector('.cookie-consent');
    if (dialog) {
        dialogPolyfill.registerDialog(dialog);

        var links = dialog.querySelectorAll('a');
        for (var i = 0; i < links.length; i++) {
            if (links[i].href === window.location.href) {
                mayShowDialog = false;
            }
        }

        if (mayShowDialog) {
            dialog.showModal();
            bodyScrollLock.disableBodyScroll(dialog);

            dialog.addEventListener('close', function (event) {
                bodyScrollLock.enableBodyScroll(dialog);
                Cookies.set('_cookies-consent', dialog.returnValue, {expires: 365});
                attachIframeTemplateListeners();

                if (dialog.returnValue === 'yes') {
                    loadTemplates();
                }
            });
        }
    }
}

function attachIframeTemplateListeners() {
    var iframeTemplates = document.querySelectorAll('template.-has-iframe');
    for (var i = 0; i < iframeTemplates.length; i++) {
        iframeTemplates[i].addEventListener('click', function (event) {
            showDialog();
        });
    }
}

function loadTemplates() {
    var consentTemplates = document.querySelectorAll('[data-consent-loading]');
    for (var i = 0; i < consentTemplates.length; i++) {
        consentTemplates[i].parentElement.replaceChild(consentTemplates[i].content, consentTemplates[i]);
    }
}

if (cookiesConsentAnswer === 'yes') {
    loadTemplates();
} else if (cookiesConsentAnswer === 'no') {
    attachIframeTemplateListeners();
}
